import VueNotifications from "vue-notifications";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const toast = ({ title = "", message = "", type, timeout, cb, ...props }) => {
  if (type === VueNotifications.types.warn) type = "warning";
  return iziToast[type]({
    title,
    message,
    timeout,
    cb,
    ...props,
  });
};

export const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

export default toast;
